module.exports = __webpack_public_path__ + "static/media/pixelfed.912fd510.svg";